var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, EventEmitter, OnInit, QueryList } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../../../../common/components/base.component';
import { ConfirmModalComponent } from '../../../../common/components/confirm.modal/confirm.modal.component';
import { ConfirmModalActions, ConfirmModalData } from '../../../../common/components/confirm.modal/confirm.modal.provider';
import { bindFunctionsToThis } from '../../../../common/extensions';
import { GoogleMapsService, TravelMode } from '../../../../common/services/google.maps.service';
import { ModalService } from '../../../../common/services/modal.service';
import { EventTimeService } from '../../../../services/event.time.service';
import { HubApiService } from '../../../../services/hub.api.service';
import { ImageService } from '../../../../services/image.service';
import { VisitorApiService } from '../../../../services/visitor.api.service';
import { AllFrontendSettingsStore, TravelModeStore, VisitorTripIdStore } from '../../../../stores/visitor.calendar.store';
import { ShareTripModalComponent } from '../../../visitor/trip/share.trip.modal/share.trip.modal.component';
import { ShareTripModalActions, ShareTripModalData } from '../../../visitor/trip/share.trip.modal/share.trip.modal.provider';
import { TripFloatDetailComponent } from '../../../visitor/trip/trip.float.detail/trip.float.detail.component';
import { EventDetailsModalActions } from "../../../visitor/event.details.modal/event.details.modal.provider";
import { EventDetailsModalComponent } from "../../../visitor/event.details.modal/event.details.modal.component";
import { HubEvent } from "../../../../models/hub/hub.event";
import { PlaceDetailsModalActions } from "../../../visitor/place.details.modal/place.details.modal.provider";
import { PlaceDetailsModalComponent } from "../../../visitor/place.details.modal/place.details.modal.component";
import { HubPlace } from "../../../../models/hub/hub.place";
var AttractionListComponent = /** @class */ (function (_super) {
    __extends(AttractionListComponent, _super);
    //@Output() onRemoveFromTrip: EventEmitter<any> = new EventEmitter();
    function AttractionListComponent(imageService, activatedRoute, hubApiService, visitorApiService, googleMapService, visitorTripIdStore, allFrontendSettingsStore, travelModeStore, modalService) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.imageService = imageService;
        _this.activatedRoute = activatedRoute;
        _this.hubApiService = hubApiService;
        _this.visitorApiService = visitorApiService;
        _this.googleMapService = googleMapService;
        _this.visitorTripIdStore = visitorTripIdStore;
        _this.allFrontendSettingsStore = allFrontendSettingsStore;
        _this.travelModeStore = travelModeStore;
        _this.modalService = modalService;
        _this.isUpdating = false;
        _this.isDragging = false;
        _this.totalTravelTime = 0;
        _this.totalTravelTimeText = '';
        _this.totalDistance = 0;
        _this.totalDistanceMiles = '';
        _this.totalDistanceKM = '';
        _this.travelMode = TravelMode.DRIVING;
        _this.dayExpanded = [];
        _this.detailsStyle = 'popup';
        _this.isDraggable = false;
        _this.isDisabled = false;
        _this.type = 'tour';
        _this.isShowAddtoMyTrip = true;
        _this.isShareable = false;
        _this.reordered = new EventEmitter();
        _this.onready = new EventEmitter();
        _this.removeFromTrip = new EventEmitter();
        _this.showRouteOnMapMobile = new EventEmitter();
        _this.showInfoWindowOnMap = new EventEmitter();
        _this.onAddToTrip = new EventEmitter();
        _this.onShowDetail = new EventEmitter();
        _this.onFloatDetailClose = new EventEmitter();
        bindFunctionsToThis(_this);
        return _this;
    }
    AttractionListComponent.prototype.ngOnInit = function () {
        var _this = this;
        var _a = this.allRouteParams, hubName = _a.hubName, tripId = _a.tripId;
        this.hubName = hubName;
        this.tripID = tripId;
        this.tour.days = [{
                title: 'Day 1',
                attractions: []
            }, {
                title: 'Day 2',
                attractions: []
            }];
        this.tour.attractions.forEach(function (x, index) {
            if (index <= _this.tour.attractions.length / 2) {
                _this.tour.days[0].attractions.push(x);
            }
            else {
                _this.tour.days[1].attractions.push(x);
            }
        });
        this.dayExpanded.push(false);
        this.dayExpanded.push(false);
        this.travelTime();
        //this.setSwapIcon();
        this.visitorTripIdStore.tripIdCommand.takeUntil(this.isDestroyed).subscribe(function (tripId) {
            _this.tripID = tripId.tripId;
        });
        this.travelModeStore.modeCommand.takeUntil(this.isDestroyed)
            .subscribe(function (mode) {
            if (mode !== _this.travelMode) {
                _this.travelMode = mode;
                _this.travelTime();
            }
        });
        this.allFrontendSettingsStore.allFrontendSettingsCommand.takeUntil(this.isDestroyed)
            .subscribe(function (command) {
            if (command.customSettings) {
                _this.detailsStyle = command.customSettings.tripPlannerDetailsStyle;
            }
        });
    };
    Object.defineProperty(AttractionListComponent.prototype, "travelModeIcon", {
        get: function () {
            if (this.travelMode === TravelMode.DRIVING)
                return 'directions_car';
            if (this.travelMode === TravelMode.BICYCLING)
                return 'directions_bike';
            if (this.travelMode === TravelMode.WALKING)
                return 'directions_walk';
            return 'menu';
        },
        enumerable: true,
        configurable: true
    });
    AttractionListComponent.prototype.changeTravelMode = function (mode) {
        this.travelMode = mode;
        this.travelTime();
        this.travelModeStore.modeCommand.next(this.travelMode);
    };
    AttractionListComponent.prototype.removeFromTour = function ($event, id) {
        var _this = this;
        if ($event) {
            $event.stopPropagation();
        }
        if (!this.isDraggable) {
            return;
        }
        var actions = {
            confirm: function (event) {
                _this.detailsPanel.closeDetails();
                _this.removeFromList(id, event);
            }
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: "Are you sure you want to remove this item from the " + this.type + "?",
            confirmModalConfirmButtonText: 'Remove',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data }
            ]
        });
    };
    AttractionListComponent.prototype.dragEnter = function ($event) {
        console.log('enter');
        if ($event && $event.currentTarget) {
            this.restoreItemStyle();
            $event.currentTarget.style.border = '2px dashed green';
        }
    };
    AttractionListComponent.prototype.startDrag = function ($event) {
        if (!this.isDragging) {
            this.isDragging = true;
        }
    };
    AttractionListComponent.prototype.onItemDrop = function (e, targetIndex) {
        var _this = this;
        this.isDragging = false;
        this.restoreItemStyle(true);
        this.reorderTour(e, targetIndex);
        if (this.type === 'trip') {
            this.travelTime();
            //if (!this.isMobile) {
            setTimeout(function () {
                _this.reordered.emit({ type: _this.type, attractions: _this.tour.attractions });
            }, 200);
            //}
        }
        else {
            this.isUpdating = true;
            this.hubApiService.updateTourAttractions(this.hubName, { id: this.tour._id, attraction: this.tour.attractions })
                .subscribe(function () {
                _this.travelTime();
                setTimeout(function () {
                    _this.reordered.emit(_this.tour.attractions);
                }, 200);
                setTimeout(function () {
                    _this.isUpdating = false;
                }, 500);
            });
        }
    };
    AttractionListComponent.prototype.showRouteOnMapForMobile = function () {
        //this.parent.parent.showDirectionMap(this.tour);
        //this.visitorTrip.showDirectionMap(this.tour);
        this.showRouteOnMapMobile.emit(this.tour);
    };
    AttractionListComponent.prototype.travelTime = function () {
        var _this = this;
        this.totalTravelTimeText = '...';
        this.totalTravelTime = 0;
        this.totalDistance = 0;
        this.totalDistanceMiles = '...';
        this.totalDistanceKM = '...';
        var waypoints = [];
        if (this.tour.attractions.length < 2) {
            return;
        }
        this.tour.attractions.forEach(function (x) {
            waypoints.push((x.item.address.lat || x.item.lat) + "," + (x.item.address.lng || x.item.lng));
        });
        this.googleMapService.getDirection(this.tour.attractions, this.travelMode, function (response) {
            if (response && response.legs && response.legs.length) {
                _this.totalTravelTime = 0;
                _this.totalDistance = 0;
                for (var _i = 0, _a = response.legs; _i < _a.length; _i++) {
                    var leg = _a[_i];
                    _this.totalTravelTime += leg.duration.value;
                    _this.totalDistance += leg.distance.value;
                    console.log('leg.distance.value', leg.distance.value);
                }
                _this.totalTravelTime = Math.round(_this.totalTravelTime / 60);
                _this.totalTravelTimeText = EventTimeService.convertToTravelTimeText(_this.totalTravelTime);
                _this.totalDistanceMiles = Math.round(_this.totalDistance / 1610) + ' miles';
                _this.totalDistanceKM = Math.round(_this.totalDistance / 1000) + ' km';
                console.log('total totalDistanceKM', _this.totalDistance);
                if (_this.type === 'tour') {
                    _this.hubApiService.updateTourTravelTimeAndDistance(_this.hubName, _this.tour._id, _this.totalTravelTime, _this.totalDistance, _this.tour.attractions.length).subscribe(function () {
                    });
                }
                _this.onready.emit();
            }
        });
    };
    AttractionListComponent.prototype.enpandAll = function () {
        this.dayExpanded[0] = true;
        this.dayExpanded[1] = true;
    };
    AttractionListComponent.prototype.dayDragEnter = function (dayIndex) {
        this.dayExpanded[dayIndex] = true;
    };
    AttractionListComponent.prototype.showDetails = function (item) {
        this.onShowDetail.emit(item);
        if (this.isMobile)
            return;
        if (this.detailsStyle === 'float') {
            this.detailsPanel.showDetails(item, '100%', '0');
            // this.detailsPanel.showDetails(item, this.isMobile ? '0' : '100%', this.isMobile ? '57px' : '0');
            return;
        }
        item.item.hubName = this.hubName;
        if (item.item.startTime) {
            var actions_1 = {
                confirm: function (event, data) {
                }
            };
            this.modalService.show({
                component: EventDetailsModalComponent,
                providers: [
                    { provide: EventDetailsModalActions, useValue: actions_1 },
                    { provide: HubEvent, useValue: item.item },
                ],
                panelClass: 'modal-fixed-top-lower'
            });
            return;
        }
        var actions = {
            confirm: function (event, data) {
            }
        };
        this.modalService.show({
            component: PlaceDetailsModalComponent,
            providers: [
                { provide: PlaceDetailsModalActions, useValue: actions },
                { provide: HubPlace, useValue: item.item },
            ],
            panelClass: 'modal-fixed-top'
        });
    };
    AttractionListComponent.prototype.swap = function (index) {
        if (!this.tour.attractions.length || this.tour.attractions.length <= index) {
            return;
        }
        this.onItemDrop({
            dragData: {
                order: index + 1
            }
        }, index);
        //this.setSwapIcon();
    };
    AttractionListComponent.prototype.showOnMap = function () {
        this.showInfoWindowOnMap.emit(this.detailAttraction.order);
        this.detailsPanel.closeDetails();
    };
    AttractionListComponent.prototype.addToTrip = function ($event) {
        this.onAddToTrip.emit($event);
    };
    AttractionListComponent.prototype.floatDetailClose = function () {
        this.onFloatDetailClose.emit();
    };
    AttractionListComponent.prototype.removeFromTripAtTour = function (id) {
        if (this.type === 'trip') {
            this.removeFromTour(null, id);
            //this.removeFromList(id);
        }
        else {
            this.removeFromTrip.emit(id);
        }
    };
    // public shareTrip() {
    //     this.showShareTripModal('trip');
    // }
    //
    AttractionListComponent.prototype.shareTour = function () {
        this.showShareTripModal('tour');
    };
    AttractionListComponent.prototype.showShareTripModal = function (type) {
        var _a = this.allRouteParams, tripId = _a.tripId, hubName = _a.hubName;
        var actions = {
            confirm: function (event, social) {
            }
        };
        this.modalService.show({
            component: ShareTripModalComponent,
            providers: [
                { provide: ShareTripModalActions, useValue: new ShareTripModalActions() },
                {
                    provide: ShareTripModalData,
                    useValue: new ShareTripModalData(type === 'trip' ? (tripId || this.tripID) : this.tour._id, hubName, type, false, '', '', 0)
                }
            ]
        });
    };
    AttractionListComponent.prototype.setSwapIcon = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.swaps) {
                _this.swaps.forEach(function (x, index) {
                    x.nativeElement.style.top = 113 * index + 100 + "px";
                });
            }
        });
    };
    AttractionListComponent.prototype.removeFromList = function (id, event) {
        var _this = this;
        if (this.type === 'trip') {
            this.removeFromTrip.emit(id);
            var index_1 = this.tour.attractions.getElementIndex(function (x) { return x.feedId === id; });
            this.attractionWrap.toArray()[index_1].nativeElement.style.opacity = '0';
            setTimeout(function () {
                _this.tour.attractions.splice(index_1, 1);
                _this.travelTime();
            }, 500);
            if (event) {
                event.complete();
            }
            return;
        }
        this.hubApiService.removeAttractionFromTour(this.hubName, { id: this.tour._id, attractionId: id })
            .finally(event && event.complete)
            .subscribe(function () {
            _this.detailsPanel.closeDetails();
            _this.hubApiService.getTourDetail(_this.hubName, _this.tour._id, _this.type === 'trip').subscribe(function (tour) {
                _this.tour = tour;
                _this.removeFromTrip.emit(tour);
                _this.travelTime();
            });
        });
    };
    AttractionListComponent.prototype.reorderTour = function (e, targetIndex) {
        this.sortAtrractionItem();
        var temp = this.tour.attractions[e.dragData.order];
        this.tour.attractions[targetIndex].order = e.dragData.order;
        this.tour.attractions[e.dragData.order] = this.tour.attractions[targetIndex];
        temp.order = targetIndex;
        this.tour.attractions[targetIndex] = temp;
    };
    AttractionListComponent.prototype.sortAtrractionItem = function () {
        if (this.tour && this.tour.attractions.length) {
            this.tour.attractions.forEach(function (x, index) {
                x.order = index;
            });
        }
    };
    AttractionListComponent.prototype.restoreItemStyle = function (isOnDrop) {
        if (isOnDrop === void 0) { isOnDrop = false; }
        this.attractionWrap.toArray().forEach(function (x) {
            x.nativeElement.style.border = '2px dashed white';
            if (isOnDrop) {
                x.nativeElement.style.borderBottom = '1px dashed lightgray';
            }
        });
    };
    return AttractionListComponent;
}(BaseComponent));
export { AttractionListComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/tours/attractions/attraction.list.component.ts.pre-build-optimizer.js